module.exports = Em.Route.extend({
    model: function() {
        return this.modelFor('bank_accounts')
    },

    afterModel: function(accounts) {
        this.replaceWith('bank_account', accounts.get('firstObject'))
    }
})
